{
  "Account": {
    "AcceptTerms": "Accetto le <a href=\"pdf/Condizioni.pdf\" target=\"_blank\"> condizioni di utilizzo</a>",
    "ConfirmEmail": {
      "ConfirmationInProgress": "La Sua e-mail verrà confermata, si prega di attendere.",
      "ConfirmationTokenFailed": "Il link è scaduto nel frattempo. Si prega di richiedere un nuovo link.",
      "EmailConfirmed": "La Sua e-mail è stata confermata. Ora è possibile accedere all'applicazione.",
      "ResendConfirmationEmailButton": "Inviare nuovamente il link.",
      "Title": "Confermare la e-mail"
    },
    "Errors": {
      "EmailInvalid": "Inserire un indirizzo e-mail valido",
      "EmailRequired": "Inserire l'indirizzo e-mail",
      "EmployedFromRequired": "Compilare il campo \"Impiegato da\"",
      "FirstNameRequired": "Inserire il proprio nome",
      "FunctionRequired": "Inserire il titolo dello specialista",
      "GlnRequired": "Il GLN è necessario per la registrazione come medico.",
      "LastNameRequired": "Inserire il proprio nome",
      "PasswordConfirmRequired": "Confermare la password",
      "PasswordRequired": "Scegliere la password",
      "PasswordsDoNotMatch": "Le password non corrispondono",
      "TermsAcceptedRequired": "È necessario accettare le condizioni di utilizzo",
      "UserNameRequired": "Inserire il nome utente"
    },
    "ForgotPassword": {
      "PasswordForgottenTitle": "Password dimenticata"
    },
    "HinLinked": {
      "BackToDashboard": "Torna alla dashboard",
      "Cancelled": "Il link di accesso a HIN è stato annullato.",
      "Error": "Non è stato possibile collegare il Suo login HIN.",
      "Success": "Il login HIN è stato collegato con successo. Ora è possibile effettuare il login con HIN."
    },
    "Login": {
      "ForgotPasswordTitle": "Password dimenticata",
      "LoginTitle": "Registrazione",
      "RegistrationTitle": "Registrazione"
    },
    "Register": {
      "AccreditedInfo": "Accreditato da (è possibile una selezione multipla)",
      "AccreditedInfoReadonly": "Accreditato automaticamente",
      "CityPlaceholder": "Luogo",
      "Delegate": "Delega",
      "Doctor": "Medico curante",
      "EmailPlaceholder": "Indirizzo e-mail",
      "ExplanationPractice": "Informazioni sullo studio o sull'istituto presso il quale il medico curante lavora in proprio o alle dipendenze di terzi.",
      "ExplanationPracticeTitle": "Spiegazione",
      "FirstnamePlaceholder": "Nome",
      "FormDataForDelegates": "Per le deleghe: Dati necessari",
      "FormDataForDoctors": "Per i medici: dati necessari per i contratti",
      "FunctionHint": "<a href=\"https://www.healthreg-public.admin.ch/medreg/search\" target=\"_blank\">Registro delle professioni mediche</a>",
      "FunctionPlaceholder": "Titolo di specialista (tutti) o funzione",
      "GlnObligatory": "<b>Il GLN è obbligatorio.</b>",
      "GlnPlaceholder": "GLN personale",
      "InstitutionGroupAdmin": "Amministratore del gruppo clinico",
      "InstitutionGroupAdminOrganisation": "Amministratore del gruppo ospedaliero",
      "InstitutionNamePlaceholder": "Istituzione/clinica",
      "Insurance": "Assicurazione",
      "InsuranceContractManager": "Responsabile dei contratti",
      "InsuranceFunctionSelection": "Selezionare la propria funzione",
      "InsurancePlaceholder": "Scegli un'assicurazione",
      "InsuranceReviewer": "Verificatore delle prestazioni",
      "InsuranceSelection": "Per quale compagnia assicurativa lavora?",
      "LastnamePlaceholder": "Cognome",
      "Others": "Altro",
      "PasswordConfimPlaceholder": "Confermare la password",
      "PasswordPlaceholder": "Scegliere la password",
      "PersonalEmailIsRequired": "Un indirizzo e-mail personale è obbligatorio per la stipula del contratto!",
      "RegisterButton": "Registro",
      "Registration": "Registrazione",
      "RegistrationInfo": "I nuovi utenti possono registrarsi qui.",
      "RegistrationInfoApprovalRequired": "L'attivazione avverrà solo dopo la verifica dell'autorizzazione.",
      "RegistrationSucceeded": "<b>Abbiamo ricevuto la sua richiesta.</b> Riceverete una e-mail non appena il Suo account sarà stato attivato.",
      "SelfIdentification": "Selezionare la funzione",
      "StreetPlaceholder": "Via",
      "Title": "Registrazione Intranet Medicalculis",
      "TitlePlaceholder": "Titolo dott. med. / prof. dott.",
      "ZSRNumberHint": "<b>Si prega di inserire il proprio numero RCC personale, se disponibile.</b><br>Il numero RCC può essere cercato <a href=\"{{zsrUrl}}\" target=\"_blank\"> qui.</a>",
      "ZSRNumberPlaceholder": "Numero RCC personale"
    },
    "ResendConfirmEmail": {
      "Errors": {
        "NoEmailSetText": "Per questo utente non è stata registrata alcuna e-mail.",
        "NoEmailSetTitle": "Nessuna e-mail registrata"
      },
      "ResendConfirmed": "La e-mail di conferma è stata nuovamente inviata. Controllare la posta in arrivo e fare clic sul link di conferma.",
      "ResendInProgress": "La e-mail di conferma verrà inviata nuovamente, si prega di attendere.",
      "Title": "Inviare nuovamente il link di conferma via e-mail"
    }
  },
  "Admin": {
    "Emails": {
      "Errors": {
        "NoEmailsSelectedText": "Selezionare almeno un registro eventi.",
        "NoEmailsSelectedTitle": "Non è stato selezionato alcun registro eventi."
      },
      "Header": "E-mail",
      "ResetMultipleEmailErrors": "Azzeramento dello stato di errore",
      "ResetMultipleEmailErrorsConfirmationDialogText": "Confermare che si desidera ripristinare lo stato di errore delle e-mail selezionate. (Verranno azzerate solo le e-mail con uno stato di errore). ",
      "ResetMultipleEmailErrorsConfirmationDialogTitle": "Azzeramento dello stato di errore"
    },
    "EventLogs": {
      "EmailsDialogTitle": "E-mail dell'EventLog \"{{id}}\"",
      "Errors": {
        "NoEventLogsSelectedText": "Selezionare almeno un registro eventi.",
        "NoEventLogsSelectedTitle": "Non è stato selezionato alcun registro eventi."
      },
      "Header": "Registri eventi",
      "ReferenceId": "ID di riferimento",
      "ReferenceType": "Tipologia di riferimento",
      "ResendEmails": "Rinvio delle e-mail",
      "ResendEmailsConfirmationDialogText": "Confermare che le e-mail per i registri eventi selezionati devono essere inviate nuovamente. (Le e-mail vengono generate nuovamente dal template e poi inviate).",
      "ResendEmailsConfirmationDialogTitle": "Rinvio delle e-mail",
      "ShowEmailsButtonToolTip": "Visualizzare le e-mail",
      "Text": "Testo",
      "Timestamp": "data",
      "Type": "Tipologia"
    },
    "Info": {
      "ApplicationLockoutEnabled": "Bloccaggio dell'applicazione ",
      "DisplayWarningMessage": "Visualizzazione del testo di avvertenza",
      "Header": "Informazioni amministratore",
      "InvoiceInfoDialogPage": "Pagina di dialogo Informazioni sulla fattura",
      "LockoutText": "Testo per il bloccaggio. (Visualizzato sulla pagina di accesso)",
      "SmsCredits": "Crediti SMS",
      "SmsSentInLastQuarter": "Totale SMS utilizzati nell'ultimo trimestre",
      "WarningMessage": "Testo di avvertenza"
    },
    "Rules": {
      "AddRule": "Aggiungere una regola",
      "Catalog": "Catalogo",
      "Context": "Contesto",
      "DeleteRule": "Cancellare la regola",
      "DeleteRuleText": "Questa regola deve per forza essere cancellata?",
      "EditRule": "Modificare la regola",
      "Errors": {
        "ContextRequired": "Il contesto deve essere compilato.",
        "ExpressionRequired": "È necessario compilare la regola.",
        "MessageRequired": "Il messaggio deve essere compilato.",
        "NameRequired": "Il nome deve essere compilato.",
        "OrderRequired": "La sequenza deve essere compilato."
      },
      "Expression": "Regola",
      "Header": "Regole",
      "IsActive": "Attivo",
      "Message": "Messaggio",
      "Order": "Sequenza",
      "ResultType": "Tipo di risultato",
      "RuleResultTypes": {
        "Error": "Errore",
        "Warning": "Avvertenza"
      },
      "Triggers": "Attivazione"
    }
  },
  "Anesthesia": {
    "Class": "Corso di anestesia",
    "ClassLabel": "Corso di anestesia {{class}}",
    "Date": "Data",
    "Duration": "Durata dell'intervento (hh:mm)",
    "DurationHours": "Orario",
    "DurationMinutes": "Minuti",
    "EmergencySurcharge": "Supplemento di emergenza 30% (000.2200.0)",
    "Errors": {
      "MinDuration": "La durata della procedura deve essere di almeno 30 minuti."
    },
    "FlatRateHint": "Nota: se disponibile, deve essere utilizzata la voce di tariffa forfettaria corrispondente (9XX.XXX.5).",
    "Preview": "Posizioni"
  },
  "BankAccount": {
    "ValidQrIban": "QR-IBAN valido",
    "ValidRegularIban": "IBAN valido"
  },
  "Catalog": {
    "CatalogItemTypes": {
      "AdditionalAssistant": "Ogni assistente aggiuntivo",
      "FirstAssistant": "Primo assistente",
      "FlatRateForAssistant": "Prestazione forfettaria per gli assistenti",
      "FlatRateForMainServiceProvider": "Servizio forfettario per il fornitore principale di servizi",
      "FlatRateSurcharge": "Supplemento per prestazione forfettaria",
      "Surcharge": "Supplemento per voce tariffaria",
      "TariffPosition": "Voce tariffaria",
      "Visit": "Visita",
      "VisitFlatRateSurcharge": "Supplemento per visita medica"
    },
    "EditCatalogItem": {
      "PreEditDialog": {
        "CreateNew": "Creare un nuovo testo",
        "EditExisting": "Modificare l'esistente",
        "Text": "Intende modificare il testo esistente oppure vuole creare una nuova annotazione sulla base di questo testo?",
        "Title": "Modifica o creazione di un testo"
      },
      "PreEditDialogOnlyEdit": {
        "Text": "Un nuovo testo è già stato creato sulla base di questa annotazione. L'annotazione può essere solo modificata.",
        "Title": "Modificare il testo"
      }
    },
    "EditCatalogView": {
      "AdditionalInfo": "Testo informativo",
      "CatalogViewOrder": "Sequenza della visualizzazione",
      "ColumnPrefix": "Colonna",
      "ColumnWidth": "Larghezza",
      "DefaultSort": "Smistamento standard",
      "Filter": "Filtro",
      "HideColumn": "Nascondere la colonna nella tabella",
      "IsActive": "Attivo",
      "ShowColumn": "Mostra la colonna nella tabella",
      "TableWidth": "Larghezza del tavolo"
    },
    "Errors": {
      "ColumnRequired": "Questa annotazione deve essere compilata.",
      "UserNotAuthorizedForCatalogViewText": "Non è autorizzato a visualizzare questo catalogo."
    },
    "Management": {
      "AddCatalogItem": "Aggiungi posizione",
      "CatalogItemFilterDate": "Filtrare le voci del catalogo per data",
      "DeleteCatalogItem": "Cancellare la posizione",
      "DeleteCatalogItemText": "Questa voce va davvero cancellata?",
      "EditCatalogItem": "Modifica posizione",
      "EditCatalogView": "Modifica della vista del catalogo",
      "ExportComparisonBaseValidDate": "Data base",
      "ExportComparisonCompareValidDate": "Data di confronto",
      "ExportDialogText": "Inserire la data di validità desiderata per l'esportazione. La data può anche essere cancellata per esportare tutti i record di dati.",
      "ExportValidDate": "Data di validità",
      "HistoryTitle": "{{uid}}Storia dell'ingresso \" \"",
      "Import": {
        "Added": "Aggiunto",
        "CurrentFile": "File corrente",
        "DropExcelToAttach": "Salvare il file Excel qui o ",
        "DropExcelToAttachLink": "ricerca",
        "ErrorCodes": {
          "HeaderRowNotFound": "Intestazione non trovata",
          "InvalidHeaderStructure": "Struttura della colonna non valida",
          "NoWorksheetFound": "Nessun foglio di lavoro trovato nel file Excel",
          "ProcessingFailed": "Elaborazione non riuscita",
          "UnexpectedError": "Errore imprevisto"
        },
        "ErrorsLabel": "Errore",
        "ImportCompletedSuccessfully": "Importazione completata con successo",
        "ImportCompletedWithErrors": "Importazione completata con errori",
        "ImportExcel": "Importazione di Excel",
        "ImportStart": "Avviare l'importazione",
        "Imported": "Importato",
        "Importing": "Importazione",
        "OverwriteExistingItems": "Sovrascrivere direttamente le voci del catalogo esistenti (senza cronologia)",
        "RowsProcessed": "Voci di catalogo elaborate",
        "Skipped": "Saltato",
        "Status": {
          "Completed": "Importazione completata",
          "Failed": "Importazione fallita",
          "Initializing": "L'importazione è inizializzata...",
          "Processing": "{{count}} Le linee vengono elaborate",
          "Saving": "Le modifiche vengono salvate nel database",
          "Starting": "L'importazione viene avviata...",
          "Unknown": "Stato sconosciuto"
        },
        "TotalRows": "Totale voci del catalogo",
        "Updated": "Aggiornato"
      },
      "ShowHistory": "Mostra la storia"
    }
  },
  "Contract": {
    "AddContract": "Aggiungere un contratto",
    "AddressHeader": "Indirizzo",
    "CashingFeeAppliedToOkp": "Tassa su OKP",
    "CashingFeeAppliedToOkpTooltip": "Se \"No\", la tassa viene addebitata solo sulla parte VVG.",
    "CompensationType": {
      "Factor": "Fattore",
      "FixedPrice": "Prezzo fisso",
      "TaxPointValue": "Valore del punto tariffario"
    },
    "DefaultTerminationDateExpressionHeader": "Data di cancellazione Regola",
    "DeleteContract": "Cancellare il contratto",
    "DeleteContractText": "Questo contratto deve essere davvero cancellato?",
    "EditContract": "Modifica del contratto",
    "EditFinalContract": "Modifica del contratto attivo",
    "EditFinalContractDialogText": "Questo contratto è già stato rilasciato. Le modifiche non saranno applicate ai singoli contratti già stipulati. Inserire un motivo per la modifica del contratto quadro attivo.",
    "EditFinalContractReasonLabel": "Motivo",
    "Errors": {
      "Factor": "Il campo deve essere compilato, il valore deve essere almeno 0 e non può superare le 4 cifre decimali.",
      "InsuranceRequiredForNonInvoiceOnlyContracts": "L'assicurazione deve essere selezionata se il contratto non è del tipo \"solo fattura\".",
      "InsuranceRequiredWhenFactorSet": "Se è impostato il fattore P1 o P2, è necessario selezionare una polizza assicurativa.",
      "OkpFactorRequiredWithoutInsurance": "Il fattore OKP deve essere maggiore di 0 se non viene selezionata alcuna assicurazione.",
      "SecondaryCatalogViewMustDifferFromCatalogViewId": "Selezionare un catalogo secondario che differisce dal catalogo.",
      "SecondaryCatalogViewWithoutCatalogView": "Selezionare innanzitutto un catalogo.",
      "TertiaryCatalogViewMustDifferFromOtherCatalogViews": "Si prega di selezionare un catalogo terziario che sia diverso dal catalogo principale e dal catalogo secondario.",
      "TertiaryCatalogViewWithoutSecondaryCatalogView": "Selezionare innanzitutto un catalogo secondario.",
      "TitleAlreadyExists": "Esiste già un contratto con questo titolo.",
      "TitleRequired": "Il titolo deve essere compilato."
    },
    "ExcludeOkpFactorPositionSpecific": "Escludere il fattore OKP per posizioni specifiche",
    "ExcludeOkpFactorPositionSpecificTooltip": "Se attivato, il fattore OKP viene escluso per gli articoli ad esso destinati. Il calcolo tiene quindi conto solo del fattore VVG e del fattore individuale.",
    "ExtendContract": "Estensione del contratto",
    "ExtendContractDialog": {
      "Text": "L'accordo quadro e tutti i contratti individuali attivi saranno prorogati alla nuova data.",
      "Title": "Estensione del contratto",
      "ValidUntilLabel": "Nuovo Valido fino alla data"
    },
    "FinalizeContractDraft": "Rilascio del contratto",
    "FinalizeContractDraftConfirmationText": "Vuole rilasciare il contratto?",
    "Header": "Contratti quadro",
    "InstitutionFactorsHint": "L'istituzione ha immagazzinato fattori OKP specifici.",
    "InstitutionGroupWarning": "Questa clinica può essere gestita in modo autonomo dal gruppo ospedaliero “{{institutionGroupName}}”. Concordate eventuali modifiche al contratto.",
    "InvoiceReceivers": "Destinatario della fattura",
    "InvoiceReceiversTooltip": "Non appena viene assegnato un destinatario della fattura, la selezione viene proposta al momento della creazione della fattura. Se non viene effettuata alcuna selezione, viene forzato il destinatario della fattura dell'istituzione.",
    "InvoicingFeeRates": {
      "AddRate": "Aggiungi una commissione",
      "CurrentRate": "{{percentage}} %",
      "CurrentRateWithScheduled": "{{percentage}} % → {{scheduledPercentage}} % in poi {{scheduledValidFrom}}",
      "DeleteRate": "Elimina",
      "Errors": {
        "NotUnique": "Per ogni data \"Valido dal\" è possibile registrare una sola commissione."
      },
      "Hint": "Per una fattura si applica la tariffa in vigore alla data di “Ricovero da” indicata sulla fattura. Le fatture già emesse mantengono sempre la tariffa originariamente applicata.",
      "Percentage": "Commissione (%)"
    },
    "IsDraft": {
      "Draft": "Bozza",
      "Final": "Attivo"
    },
    "IsForSpecialistsOnly": "Solo per medici specialisti",
    "IsForSpecialistsOnlyTooltip": "Se attivato, il contratto può essere utilizzato solo da medici specialisti.",
    "NoInvoiceReceiverOption": "Nessun destinatario di fattura elettronica",
    "NoInvoiceReceiverOptionTooltip": "Solo se attivata, la voce \"Nessun destinatario della fattura elettronica\" può essere selezionata durante la creazione della fattura.",
    "OfferValidityManagedExternally": "Le impostazioni relative alle offerte vengono gestite in Contracto Insurance.",
    "OfferValidityWeeksValue": "Validità dell'offerta: {{weeks}} settimane.",
    "ParentContractHeader": "Contratto subordinato",
    "Pdf": {
      "Pdf02Title": "Supplemento 1",
      "Pdf02TitleLabel": "Supplemento 1 (facoltativo)",
      "Pdf03Title": "Supplemento 2",
      "Pdf03TitleLabel": "Supplemento 2 (facoltativo)",
      "PdfTitle": "Contratto"
    },
    "SaveDraft": "Salvare la bozza",
    "SecondaryCatalogView": "Catalogo secondario",
    "SecondaryCatalogViewTooltip": "Se impostato, il catalogo è disponibile come secondo catalogo per la fatturazione.",
    "SignatureHeader": "Firma",
    "StartPhaseEndValue": "Fase iniziale fino a {{date}}.",
    "Status": {
      "Active": "Attivo",
      "ContractWasValidUntil": "Il contratto era valido fino al {{validUntilDate}}.",
      "Denied": "Rifiutato",
      "InProcessing": "In lavorazione",
      "OfferDeadline": "Offerta valida fino al {{offerDeadlineDate}}.",
      "Replaced": "Sostituisce",
      "Terminated": "Annullato",
      "TerminatedDate": "È stato annullato il {{terminatedDate}}{{terminatedBy}}.",
      "UserConfirmationPending": "Conferma da parte dell'utente in corso",
      "UserConfirmationPendingInSentence": "Conferma da parte dell'utente in sospeso.",
      "UserDeclined": "Offerta rifiutata"
    },
    "TerminationType": {
      "AutomaticallyTerminated": "Annullato automaticamente",
      "AutomaticallyTerminatedInSentence": " automaticamente",
      "TerminatedByInsurance": "Annullato dall'assicurazione",
      "TerminatedByInsuranceInSentence": "Dell'assicurazione",
      "TerminatedByUser": "Annullato dall'utente",
      "TerminatedByUserInSentence": " dall'utente",
      "Title": "Tipo di annullazione"
    },
    "TertiaryCatalogView": "Catalogo terziario",
    "TertiaryCatalogViewTooltip": "Se impostato, il catalogo è disponibile come terzo catalogo in fase di fatturazione.",
    "Type": {
      "InvoiceOnly": "Solo per la fattura",
      "Standard": "Standard",
      "UserMustConfirm": "Conferma dell'utente"
    },
    "TypeLabel": "Tipologia",
    "ValidFromEmptyHint": "Per i contratti individuali, la data odierna viene utilizzata come data di inizio predefinita.",
    "ValidFromOpen": "Senza data di inizio",
    "ValidUntilChangeWarning": "Attenzione: se la data \"Valido fino a\" viene modificata, i singoli contratti non vengono adeguati automaticamente. Utilizzare la funzione \"Estendi contratto\" per aggiornare anche i singoli contratti.",
    "ValidUntilUnlimited": "Durata indederminata",
    "WithdrawalPeriodHeader": "Periodo di recesso "
  },
  "Dashboard": {
    "InfoText": "<h4>Testo di esempio</h4>"
  },
  "DataTable": {
    "AddRowTitle": "Aggiungere un record di dati",
    "DeleteRowText": "Questo record di dati deve essere per forza cancellato?",
    "DeleteRowTitle": "Cancellare il record di dati",
    "EditRowTitle": "Modifica del record di dati"
  },
  "Dialog": {
    "AcceptTermsDialog": {
      "AcceptTermsCheckboxText": "Accetto le condizioni di utilizzo"
    },
    "EditEmployeeContainerComponent": {
      "ZSRNumberHint": "È possibile cercare il numero RCC <a href=\"{{zsrUrl}}\" target=\"_blank\">qui.</a>"
    },
    "EditInvoiceContainerComponent": {
      "CaseNumber": "Numero del caso",
      "CaseNumberPlaceholder": "ad esempio, 1549876127",
      "PIDOptional": "PID (opzionale)"
    },
    "EditInvoiceInsuranceContainerComponent": {
      "FactorsCannotBeChanged": "I fattori non possono essere modificati per questo tipo di contratto.",
      "FactorsDifferently": "Diversi fattori in contratti selezionati.",
      "FieldWillBeChanged": "Questo campo viene regolato per tutti i contratti selezionati.",
      "FieldWillNotBeChanged": "Questo campo non è personalizzato.",
      "NoBaseFactor": "Fattore non disponibile nel contratto base."
    },
    "EditInvoiceSessionContainerComponent": {
      "Errors": {
        "ManualValueRequired": "Si prega di inserire un valore per la potenza {{positionNumbers}}.",
        "SessionDateRequired": "La data della seduta deve essere compilata."
      },
      "MostUsedPositions": "Utilizzato di frequente",
      "Performances": "Prestazioni",
      "RemoveServiceProvider": "Rimuovere {{ serviceProviderDisplay }} come fornitore di servizi",
      "SelectedPerformances": "Prestazioni selezionate",
      "SelectedSurcharges": "Supplementi selezionati",
      "SessionDate": "Data della seduta",
      "SetMainItem": "Impostato come prestazione principale",
      "SetServiceProvider": "Impostazione del fornitore di servizi deviante",
      "ShowAllPositions": "Mostra tutti",
      "Suggestions": "Servizi adeguati",
      "Surcharges": "Supplementi"
    },
    "EditPositionServiceProvider": {
      "ServiceProvidersInSession": "Fornitori di servizi già in uso"
    },
    "FileUploadDialog": {
      "Errors": {
        "RequestTooLargeText": "I file selezionati superano il limite di upload dei file. Se sta caricando più file, puo'  provare a caricarli singolarmente.",
        "RequestTooLargeTitle": "Limite di file raggiunto"
      },
      "Files": "File",
      "OrDropHere": "Oppure depositare qui tramite drag & drop.",
      "SaveSecure": "Caricare i file in un archivio sicuro. (Può essere scaricato solo con il login)",
      "SelectFiles": "Selezionare i file",
      "ShouldOverwriteFiles": "I file devono essere sovrascritti?",
      "Title": "Caricare i file",
      "Upload": "Caricare"
    },
    "InfoLinkDialog": {
      "Errors": {
        "LinkRequired": "Il link deve essere compilato.",
        "RequestTooLargeText": "Il file selezionato supera il limite di upload dei file.",
        "RequestTooLargeTitle": "Limite file raggiunto"
      },
      "File": "File",
      "OrDropHere": "Oppure depositare qui tramite drag & drop.",
      "SelectFile": "Selezionare il file",
      "Title": "Link informativo",
      "Upload": "Aggiungi link informativo"
    },
    "ServiceTypeConfigDialogComponent": {
      "ServiceProvider": "Fornitore di servizi (diverso dalla parte che emette la fattura)",
      "ServiceProviderType": "Categoria medici",
      "ServiceProviderTypeRequired": "Selezionare una categoria",
      "ServiceType": "Tipo",
      "Title": "Selezionare i tipi di servizio"
    },
    "SmsVerificationDialog": {
      "Title": "Conferma via SMS"
    }
  },
  "Email": {
    "Columns": {
      "CC": "CC",
      "CreateDate": "Creato",
      "ErrorCounter": "Numero di errori",
      "From": "Da",
      "Priority": "Priorità",
      "SendDate": "Inviato",
      "Status": "Stato attuale",
      "Subject": "Soggetto",
      "To": "A"
    },
    "Status": {
      "Error": "Errore di trasmissione",
      "Pending": "In fila di attesa",
      "Sending": "Verrà inviato",
      "Sent": "Inviato"
    }
  },
  "Employee": {
    "Errors": {
      "GlnRequired": "Inserire il numero GLN.",
      "OnlyNaturalPersons": "Solo le persone fisiche possono essere create come dipendenti.",
      "SaveAnyways": "Dovrebbe essere comunque salvato?"
    },
    "Management": {
      "AddAssistant": "Aggiungi assistente",
      "AddEmployee": "Aggiungi un medico",
      "EditEmployee": "Modifica medico",
      "FilterContractToDo": "Mostra solo le richieste senza contratto o con conferma in sospeso."
    },
    "Search": {
      "Hint": "Selezionare un medico (persona fisica) da <a href=\"https://www.refdata.ch/de/partner/abfrage/partner-refdatabase-gln\" target=\"_blank\">Refdata</a> cercando qui per GLN o cognome:",
      "NoResults": "Nessun risultato trovato",
      "Results": "Risultati della ricerca",
      "SearchBy": "Ricerca di",
      "SearchTermGln": "GLN",
      "SearchTermLastName": "Cognome",
      "Title": "Selezionare il medico"
    }
  },
  "ErrorHandler": {
    "BackendOfflineErrorText": "Il server non è attualmente disponibile. Riprovare più tardi o contattare l'amministratore.",
    "BackendOfflineErrorTitle": "Server non disponibile",
    "BadRequestTitle": "Errore",
    "ForbiddenText": "Non è autorizzato per questo modulo.",
    "ForbiddenTitle": "Non autorizzato",
    "InternalServerErrorDevTitle": "Errore nell'API",
    "InternalServerErrorProdText": "Si è verificato un errore imprevisto. Se il problema persiste, contattare l'amministratore.",
    "InternalServerErrorProdTitle": "Errore imprevisto",
    "ReloadApplication": "Ricarica l'applicazione",
    "SessionExpiredText": "La sua sessione è scaduta. Si prega di effettuare nuovamente l'accesso.",
    "SessionExpiredTitle": "La sessione è scaduta",
    "TooManyRequestsErrorText": "Sono state inviate troppe richieste in poco tempo. Riprovare tra qualche {{retryAfter}} secondo.",
    "TooManyRequestsErrorTitle": "Troppe richieste",
    "UserLockoutText": "L'accesso all'applicazione è bloccato o non è ancora stato abilitato.",
    "UserLockoutTitle": "Utente bloccato",
    "WarningTitle": "Avvertenze"
  },
  "Favorites": {
    "AddToFavorites": "Aggiungi ai preferiti",
    "All": "Tutti i preferiti",
    "DefaultFolder": "I preferiti",
    "DialogTitle": "Salva come preferito",
    "Folder": "Cartella",
    "NewFolder": "Nuova cartella",
    "RemoveFromFavorites": "Rimuovi dai preferiti",
    "Title": "I preferiti"
  },
  "Global": {
    "AccountType": "Tipo di conto",
    "ActiveFrom": "Attivo da",
    "ActiveUntil": "Attivo fino a ",
    "All": "Tutti",
    "ApplicationUpdateAvailable": "È disponibile una nuova versione del sito web. Fare clic su Ok per ricaricare la pagina.",
    "ApplicationUpdateAvailableTitle": "Nuova versione disponibile",
    "ApprovalReason": {
      "DelegateUserType": "Automatizzato grazie alla Delega della classe utente",
      "ExternalInstitutionData": "Automatizzato tramite la sincronizzazione dei dati dell'istituto"
    },
    "ApprovedBy": "Sbloccato da",
    "ApprovedDate": "Sbloccato il",
    "Assistant": "Assistente",
    "BESR": "Riferimento QR",
    "BackToLoginButton": "Torna al login",
    "BankAccount": "Coordinate bancarie",
    "BankAccountIban": "IBAN",
    "BankAccountIbanOrQrIban": "IBAN / QR-IBAN",
    "BankAccountIbanTooltip": "In fase di fatturazione, per alcuni destinatari della fattura è richiesto un QR-IBAN.",
    "BankAccountQrIban": "QR-IBAN",
    "Cancel": "Interrompere",
    "Canton": "Canton",
    "CaseNumber": "Numero del caso",
    "Catalog": "Catalogo",
    "CatalogItems": "Posizioni in catalogo",
    "CatalogView": "Vista del catalogo",
    "CatalogViews": "Visualizzazioni del catalogo",
    "Choose": "Selezionare",
    "City": "Luogo",
    "ClearFilter": "Elimina il filtro",
    "Close": "Chiudere",
    "CloseDialog": "Chiudere il dialogo",
    "CompensationType": "Tipo di retribuzione",
    "Contract": "Contratto",
    "ContractContactInformation": "Informazioni di contatto",
    "ContractContactInformationHeader": "Contattateci",
    "ContractContactInformationTooltip": "Mostra informazioni di contatto",
    "ContractContent": "Contenuto del contratto",
    "ContractDoctors": "Medici del panel",
    "Contracts": "Contratti",
    "ControllingForInvoiceReceiver": "Controllo delle fatture per i destinatari delle stesse",
    "ControllingForInvoiceReceiverInfo": "L'utente può visualizzare, confermare e rifiutare le fatture dei destinatari selezionati.",
    "Copy": "Copia",
    "Count": "Quantità",
    "CreatedBy": "Inserito da",
    "CsvExport": "Esportazione CSV",
    "Date": "data",
    "DateOfBirth": "Data di nascita",
    "DeclineReason": "Motivo del rifiuto",
    "Decrease": "Diminuzione",
    "Delegations": "Delega",
    "Delete": "Cancellare",
    "Description": "Descrizione",
    "Details": "dettagli",
    "DontShowAgain": "Non visualizzare più",
    "Draft": "Bozza",
    "EMail": "e-mail",
    "Edit": "Modifica",
    "EmailConfirmed": "E-mail confermata",
    "EmployedFrom": "Impiegato da",
    "EmployedUntil": "Impiegato fino a",
    "Employee": "Elenco dei medici",
    "EmployeeGroups": "Elenchi di medici",
    "Enlarge": "Ingrandire",
    "Errors": {
      "BankAccountIbanInvalid": "Inserire un IBAN valido.",
      "DateIsRequired": "Inserire la data.",
      "FieldIsRequired": "Compilare questo settore",
      "GlnInvalid": "Il GLN non è valido.",
      "GlnLength": "Il GLN deve essere composto da 13 cifre.",
      "GlnPatternInvalid": "Formato non valido del GLN.",
      "GlnRequired": "Il GLN deve essere completato.",
      "GlnServiceUnavailable": "Non è stato possibile verificare il GLN, poiché il servizio di verifica non è attualmente disponibile.",
      "InvalidDate": "Data non valida.",
      "LoadFailed": "Non è stato possibile caricare i dati.",
      "MaxLength": "Si prega di utilizzare un massimo di {{limit}} caratteri",
      "MobilePhoneNumberPattern": "Inserire il numero nel formato +41XXXXXXXXX.",
      "MobilePhoneNumberRequired": "È richiesto il numero di cellulare.",
      "PostalCodeInvalid": "Inserire un codice postale numerico",
      "PostalCodeRequired": "Inserire un codice postale.",
      "QrReferencePrefixInvalid": "Il valore deve essere numerico",
      "SaveFailed": "Salvataggio non riuscito.",
      "TextIsRequired": "Compilare il testo.",
      "TextTooShort": "Inserire altro testo.",
      "ValidFromMustBeBeforeValidUntil": "La data deve essere precedente alla data di scadenza.",
      "ValidFromRequired": "Indicare la data di inizio della validità.",
      "ValidUntilMustBeAfterValidFrom": "La data deve essere successiva alla data di validità.",
      "ZsrNumberInvalid": "Formato non valido del numero RCC."
    },
    "Evaluation": "Valutazione",
    "ExcelExport": "Esportazione in Excel",
    "ExcelExportComparison": "Confronto tra esportazioni in Excel",
    "Factor": "Fattore",
    "FactorP1": "Privato",
    "FactorP2": "Semi-privato",
    "FirstName": "Nome",
    "For": "per",
    "Frequency": "Frequenza",
    "FunctionTitle": "Titolo di specialista",
    "Gender": "Genere",
    "GenderFemale": "donna",
    "GenderMale": "uomo",
    "Gln": "GLN",
    "GlnHint": "È possibile cercare il GLN <a href=\"https://www.refdata.ch/de/partner/abfrage/partner-refdatabase-gln\" target=\"_blank\"> qui.</a>",
    "Groups": "Gruppi",
    "GuestAssistant": "Assistente ospite",
    "GuestDoctor": "Medico ospite",
    "GuestDoctors": "Medici ospiti",
    "HospitalizationFrom": "Ricovero in ospedale da",
    "HospitalizationUntil": "Ricovero in ospedale fino a",
    "Id": "Id",
    "Identifier": "Identificatore",
    "Increase": "Aumento",
    "IndividualFactor": "Fattore individuale",
    "IndividualFactorShort": "Fattore ind.",
    "Info": "Info",
    "InfoLinks": "Link informativi",
    "Institution": "Istituzione",
    "InstitutionClinic": "Istituzione/clinica",
    "InstitutionPractice": "Nome dello studio/istituto",
    "Institutions": "Istituzioni",
    "Insurance": "Assicurazione",
    "InsuranceType": "Tipo di assicurazione",
    "InsuranceTypeGeneral": "Generale",
    "InsuranceTypePrivate": "Privato",
    "InsuranceTypeSemiPrivate": "Semi-privato",
    "Insurances": "Assicurazioni",
    "Invoice": "Fattura",
    "InvoiceDate": "Data della fattura",
    "InvoiceReceiver": "Destinatario della fattura",
    "InvoiceReceiverSettingsButton": "Impostazioni per {{invoiceReceiverTitle}}",
    "InvoiceReceiverSettingsHint": "Impostazioni per i destinatari delle fatture per questo utente. Rilevante solo se l'utente utilizza questo destinatario per le fatture.",
    "InvoiceReceivers": "Destinatario della fattura",
    "Invoices": "Fatture",
    "InvoicingFee": "Tariffa",
    "InvoicingZsrNumber": "N. RCC per la fatturazione",
    "InvoicingZsrNumberHint": "<b>Inserire un RCC diverso (RCC dello studio) se non si fattura con il proprio RCC personale.<br>I numeri K (6 cifre + lettera) non sono ammessi.</b><br><a href=\"{{zsrUrl}}\" target=\"_blank\">Qui</a> è possibile cercare il numero di RCC.",
    "KeyboardHints": {
      "ArrowKeysSelect": "Seleziona ↑↓",
      "EnterApply": "Inserisci e conferma",
      "EscClose": "Esc: chiudi"
    },
    "Kind": "Tipo",
    "Language": "Lingua",
    "LastChange": "Ultima modifica",
    "LastLogin": "Ultimo accesso",
    "LastName": "Cognome",
    "MainPerformance": "Prestazione principale",
    "MainServiceProvider": "Principale fornitore di servizi",
    "Memo": "Memo",
    "MobilePhoneNumber": "No. di cellulare",
    "Name": "Nome",
    "No": "No",
    "NoResults": "Nessun risultato trovato",
    "Nr": "No.",
    "Number": "Numero",
    "OKPFactor": "Fattore AOMS",
    "ObjectPermissions": "Autorizzazioni per gli oggetti",
    "Ok": "Ok",
    "OverallFactorP1": "Totale privato",
    "OverallFactorP2": "Totale semi-privato",
    "PID": "PID",
    "Password": "password",
    "PatientID": "ID paziente",
    "PdfExport": "Esportazione Pdf",
    "PhoneNumber": "Numero di telefono",
    "PleaseSelect": "Selezionare",
    "PositionValue": "Valore della posizione",
    "PostalCode": "CAP",
    "Refresh": "Aggiornare",
    "Remove": "Rimuovere",
    "ResultCount": {
      "Plural": "Risultati",
      "Singular": "Risultato"
    },
    "Retry": "Riprovare",
    "Roles": "Rulli",
    "Save": "Salvare",
    "SaveAnyway": "Salva comunque",
    "Search": "Ricerca",
    "Select": "Selezionare",
    "SelectAll": "Seleziona tutto",
    "SelectDateRange": "Selezionare l'intervallo di date",
    "SelectedCount": "{{count}} selezionato",
    "SentAt": "Spedito il",
    "ServiceProvider": "Fornitore di prestazioni",
    "ServiceText": "Testo della prestazione",
    "Sessions": "Sedute",
    "ShowDetails": "Visualizzare i dettagli",
    "ShowLess": "mostra meno",
    "ShowMore": "Visualizzare tutto",
    "Shrink": "Ridimensionamento",
    "Specialist": "Specialista",
    "SpecialistHint": "Gli utenti contrassegnati con \"Specialista\" possono utilizzare accordi quadro destinati esclusivamente agli specialisti.",
    "State": "Stato",
    "Street": "Via",
    "SubTotalTaxPoints": "Subtotale punti tariffari ",
    "Surcharge": "Supplemento",
    "SurchargeFactor": "Fattore Supplemento",
    "Title": "Titolo",
    "Total": "Totale",
    "TotalTaxPoints": "Totale punti tariffari ",
    "TreatmentDate": "Data del trattamento",
    "Type": "Tipo",
    "TypeHereToSearch": "Clicca qui per effettuare la ricerca",
    "Unknown": "Sconosciuto",
    "UsedAs": "Utillizzato come",
    "User": "Utenti",
    "UserContracts": "Contratti utenti",
    "UserInfo": "Info utente",
    "UserName": "Nome utente",
    "UserType": "Classe utente",
    "VVGFactorP1": "LCA privato",
    "VVGFactorP1WithCompensationType": "{{compensationType}} LCA privato",
    "VVGFactorP2": "LCA semiprivato",
    "VVGFactorP2WithCompensationType": "{{compensationType}} LCA semiprivato",
    "ValidFrom": "Valido da",
    "ValidFromOnActivation": "a partire dall'attivazione",
    "ValidPermanent": "Durata indederminata",
    "ValidUntil": "Valido fino a",
    "Valuation": "Valutazione",
    "Value": "Valore",
    "Visit": "Visita",
    "WithoutGroup": "Senza gruppo",
    "WithoutInstitution": "Senza istituzione",
    "Yes": "Sì",
    "ZsrNumber": "No. RCC"
  },
  "Home": {
    "BrowserModal": {
      "ButtonText": "Utilizzate comunque il sito web",
      "Text": "{{browserName}}<br><br>Il browser ' ' non è più ufficialmente supportato e potrebbe non essere in grado di utilizzare tutte le funzioni di questo sito web con questo browser.",
      "Title": "Browser non supportato"
    },
    "ForgotPasswordButton": "Richiesta di una nuova password",
    "ForgotPasswordInfo": "Se vi siete già registrati e avete dimenticato la password, potete richiederne una nuova qui.",
    "Info": "<ul><li>Come nuovo utente, dovete innanzitutto registrarvi (nuova registrazione). </li><li style=\"margin-bottom:10px;\">La vostra registrazione sarà verificata e riceverete un'e-mail non appena potrete utilizzare il sito.</li><li> Il vostro nome utente è l'indirizzo e-mail con cui vi siete registrati.</li><li>Dopo aver effettuato il login, sarete portati alla homepage della rete intranet Medicalculis.</li><li> Da qui potrete navigare verso le valutazioni delle prestazioni e i contratti.</li></ul>",
    "Login": {
      "EmailPassword": "Accesso con e-mail e password",
      "HIN": "Accesso con HIN"
    },
    "RegisterButton": "Nuova registrazione",
    "Title": "Intranet Medicalculis"
  },
  "IndividualCompensation": {
    "AddIndividualCompensation": "Aggiungi fattore",
    "DeleteIndividualCompensation": "Cancellare",
    "Errors": {
      "NotUnique": "Il fattore individuale deve essere unico."
    },
    "Header": "Fattori",
    "IsDefault": "Selezione standard",
    "Reference": "Gruppo fornitore di prestazioni"
  },
  "Info": {
    "AddInfoLink": "Aggiungi link informativo",
    "DeleteInfoLink": "Info Collegamento di cancellazione",
    "DeleteInfoLinkText": "Questo link informativo dovrebbe davvero essere cancellato?",
    "EditInfoLink": "Modifica il link informativo",
    "EditInfoLinks": "Info Collegamenti di modifica",
    "GeneralInfoLinks": "In generale",
    "Header": "Info",
    "InstitutionSpecificInfoLinks": "Specifico per l'istituzione",
    "InstitutionsForPhysician": "Limitare la visibilità ai medici affiliati alle seguenti istituzioni:",
    "InstitutionsWithoutGroup": "Senza gruppo ospedaliero",
    "InsurancesForUserClass": "Limita la visibilità agli utenti delle seguenti assicurazioni:",
    "IsPublic": "Visibile per tutti gli utenti",
    "LinkAction": {
      "DownloadFile": "Scarica il file",
      "OpenInNewTab": "Aprire un link non protetto in una nuova scheda",
      "OpenPdf": "Aprire il PDF protetto in una nuova scheda",
      "OpenPdfDialog": "Aprire il PDF nel dialogo"
    },
    "LinkActionHeader": "Azione di collegamento",
    "LinkHeader": "Collegamento",
    "Order": "Sequenza",
    "UploadFiles": "Caricare i file",
    "UserGroupPermissionHint": "La visibilità dei link può essere impostata anche tramite i gruppi.",
    "Visibility": "Visibilità"
  },
  "Institution": {
    "AddInstitution": "Aggiungi istituzione",
    "Cantons": {
      "Ag": "Argovia",
      "Ai": "Appenzello Interno",
      "Ar": "Appenzello Esterno",
      "Be": "Berna",
      "Bl": "Basilea Campagna",
      "Bs": "Basilea Città",
      "Fr": "Friburgo",
      "Ge": "Ginevra",
      "Gl": "Glarona",
      "Gr": "Grigioni",
      "Ju": "Giura",
      "Lu": "Lucerna",
      "Ne": "Neuchâtel",
      "Nw": "Nidvaldo",
      "Ow": "Obvaldo",
      "Sg": "San Gallo",
      "Sh": "Sciaffusa",
      "So": "Soletta",
      "Sz": "Svitto",
      "Tg": "Turgovia",
      "Ti": "Ticino",
      "Ur": "Uri",
      "Vd": "Vad",
      "Vs": "Vallese",
      "Zg": "Zugo",
      "Zh": "Zurigo"
    },
    "CaseNumberRequired": "Il numero del caso è un campo obbligatorio",
    "DeleteInstitution": "Cancellare l'istituzione",
    "DeleteInstitutionText": "Questa istituzione dovrebbe davvero essere cancellata?",
    "EditInstitution": "Modifica istituzione",
    "Errors": {
      "CantonFormat": "Cantone da compilare (per lo scambio di dati del Forum)",
      "TitleRequired": "Il titolo deve essere compilato.",
      "ZsrFormat": "Lo RCC deve essere composto da una lettera seguita da sei numeri."
    },
    "Factors": {
      "AddFactor": "Aggiungere un fattore",
      "ClearValidUntil": "Valido fino alla cancellazione",
      "Columns": {
        "ExternalCode": "Esterno",
        "MedRegCode": "MedReg",
        "OkpFactor": "OKP",
        "Qualification": "Gruppo di specialisti"
      },
      "ConfirmDelete": "Cancellare davvero questo fattore?",
      "DeleteFactor": "Cancellare il fattore",
      "Description": "Questi fattori vengono applicati indipendentemente dal contratto se il fornitore di servizi possiede il corrispondente titolo specialistico convalidato.",
      "EditFactor": "Fattore di modifica",
      "EditValidUntil": "Valido fino alla modifica - {{qualification}}",
      "Errors": {
        "OkpFactorBoundaries": "Il fattore OKP deve essere compreso tra {{min}} e {{max}} .",
        "OverlappingFactor": "Il fattore si sovrappone a un fattore esistente.",
        "ValidUntilMustBeAfterValidFrom": "Valido fino a deve essere successivo a Valido da."
      },
      "FactorInUse": "Questo fattore è già stato utilizzato (l'ultima volta su {{date}}) e non può più essere modificato.",
      "FactorInUseValidUntilOnly": "Ultimo utilizzo su {{date}} - solo \"Valido fino a\" può essere modificato.",
      "FilterByQualification": "Filtrare per gruppo di specialità",
      "ManageButton": "Gestire i fattori istituzionali",
      "NewFactor": "Fattore nuovo",
      "ResultCount": {
        "All": {
          "Plural": "Fattori",
          "Singular": "Fattore"
        },
        "CurrentlyValid": {
          "Plural": "fattori validi oggi",
          "Singular": "fattore valido oggi"
        }
      },
      "SelectQualification": "Selezionare un gruppo specializzato",
      "ShowAll": "Mostra tutti",
      "ShowOnlyCurrentlyValid": "Mostra solo quelli attualmente validi",
      "Title": "Fattori istituzionali"
    },
    "GlnEmptyHint": "Per le istituzioni è necessario inserire un GLN. Lasciare il campo vuoto solo in casi eccezionali e debitamente motivati.",
    "Header": "Istituzioni",
    "InstitutionGroup": "Gruppo di cliniche",
    "InstitutionGroupAdmin": "Amministratore per il gruppo di cliniche",
    "InstitutionGroupDetails": "Dettagli del gruppo",
    "InstitutionGroupIdentityProvider": "Fornitore di identità",
    "InstitutionGroupSubDomain": "Sottodominio",
    "InstitutionGroupTooltip": "Specifica a quale gruppo di cliniche appartiene l'istituzione. Gli amministratori di questo gruppo possono gestire i relativi utenti. Inoltre, al momento della registrazione, l'istituzione appare tramite il sottodominio corrispondente.",
    "InstitutionGroupUserDomain": "Dominio utente",
    "InvoiceReceiverCopyOnly": "(solo copia)",
    "InvoiceReceiverTooltip": "L'invio al destinatario viene eseguito a meno che non sia configurato diversamente nel contratto"
  },
  "Insurance": {
    "AddInsurance": "Aggiungere l'assicurazione",
    "DeleteInsurance": "Cancellare l'assicurazione",
    "DeleteInsuranceText": "L'assicurazione deve essere cancellata?",
    "EditInsurance": "Modifica assicurazione",
    "Errors": {
      "TitleRequired": "Il titolo deve essere compilato."
    },
    "GlnEmptyHint": "Senza il codice GLN, questa assicurazione non può essere utilizzata per le fatture.",
    "Header": "Assicurazioni",
    "ParentInsurance": "Rappresentato da",
    "PendingUserContracts": {
      "AcceptContractsDialogText": "Si prega di confermare che si desidera accettare/offrire i contratti selezionati.",
      "AcceptContractsDialogTitle": "Accettare/offrire contratti",
      "AcceptSelected": "Accettare/offrire contrassegnati",
      "CannotEditFactorsHint": "<br>Sono stati selezionati contratti con contratti base diversi o tipi di contratto diversi, pertanto i fattori non possono essere modificati. I fattori possono essere modificati solo per i contratti che devono essere confermati dall'utente.",
      "DeclineContractsDialogText": "Confermare che si desidera rifiutare i contratti contrassegnati.",
      "DeclineContractsDialogTitle": "Rifiutare i contratti",
      "DeclineSelected": "Rifiutare il contrassegnato",
      "EditAndAcceptSelected": "Modificare e accettare/offrire quelli contrassegnati",
      "EditUserContract": "Modifica del contratto",
      "Header": "Contratti in sospeso"
    },
    "PhysicianSearchHirslanden": "Ricerca medici Hirslanden",
    "UserContracts": {
      "ContractChangesExcelReport": "Esportazione in Excel delle modifiche contrattuali",
      "Header": "Contratti",
      "SelectTerminationDateDialog": {
        "AdditionalTextLabel": "Motivo (sarà inviato per e-mail)",
        "TerminationDateLabel": "Disdetta il (data) ",
        "Title": "Disdetta dei contratti",
        "VariousTerminationDatesHint": "Non tutti i contratti hanno la stessa data di disdetta standard. Se si inserisce una data qui, la data di disdetta selezionata verrà utilizzata per tutti i contratti."
      },
      "TerminateContractsDialogText": "Confermare che si desidera disdire i contratti contrassegnati",
      "TerminateContractsDialogTitle": "Disdetta dei contratti",
      "TerminateSelected": "Annullamento contrassegnato"
    }
  },
  "Invoice": {
    "AcceptTermsDialog": {
      "Text": "Per utilizzare Fattura, accettare le condizioni d'uso.",
      "Title": "Condizioni di utilizzo della fattura"
    },
    "Controlling": {
      "ApproveInvoice": "Contrassegnare la fattura come incassata",
      "ApproveInvoiceDialogText": "Si prega di confermare che si desidera contrassegnare la fattura come incassata.",
      "DeclineInvoice": "Rifiuto della fattura",
      "DeclineInvoiceDialogText": "Indicare il motivo per cui la fattura è stata respinta. <br>Il testo verrà inviato all'utente via e-mail, quindi non inserire i dati del paziente.",
      "ShowInvoice": "Mostra fattura"
    },
    "DeclinedDate": "Rifiutato su",
    "Delegations": {
      "AddDelegation": "Aggiungere la delega",
      "DelegateNotRegistered": "Conto non registrato presso Contracto o non ancora collegato a Hirslanden.",
      "Description": "I seguenti utenti possono creare fatture a vostro nome:",
      "Dialog": {
        "AllInstitutionsTooltip": "Il vostro delega può emettere automaticamente le fatture alle istituzioni con le quali avete stipulato un contratto come medico curante",
        "ButtonCancel": "Interrompere",
        "ButtonDelete": "Termina delega",
        "ButtonInvite": "Invito",
        "ButtonUpdate": "Aggiornare",
        "ConfirmationCreate": "Con <strong>Invito</strong> confermate che la persona specificata può creare fatture a vostro nome",
        "ConfirmationUpdate": "Utilizzare <strong>Aggiornare</strong> per modificare le autorizzazioni della delega",
        "DescriptionCreate": "Invitate una persona che possa creare fatture per voi come delega",
        "DescriptionEdit": "Modificare la delega e le sue autorizzazioni",
        "EmailLabel": "Indirizzo e-mail della delega",
        "EmailNotFound": "L'indirizzo e-mail non è stato trovato. La persona deve essere già registrata come delega per poter essere aggiunta.",
        "EmailRequired": "Inserire un indirizzo e-mail valido",
        "EmailValidated": "Indirizzo e-mail convalidato con successo",
        "EmailValidationError": "Errore durante la convalida",
        "ErrorCreate": "Errori durante la creazione della delega",
        "ErrorDelete": "Errore nel terminare la delega",
        "ErrorUpdate": "Errore durante l'aggiornamento della delega",
        "InstitutionQuestion": "Per quali istituzioni la delega può emettere fatture?",
        "InstitutionRestrictedTooltip": "Questa istituzione è gestita esternamente.",
        "InvalidUserTypeError": "L'utente non possiede la classe utente richiesta \"Delega\".",
        "InvalidUserTypeTooltip": "Non è possibile aggiornare o terminare la delega.",
        "ModeAllInstitutions": "Tutte le istituzioni",
        "ModeSpecificInstitutions": "Solo alcune istituzioni",
        "NoInternalInstitutions": "Selezionare almeno un istituto",
        "RestrictedInstitutionsTitle": "Istituzioni dell'Hirslanden",
        "RestrictedInstitutionsWarning": "Le deleghe per le istituzioni Hirslanden sono gestite nella <a href=\"https://fiori.hirslanden.ch/\" target=\"_blank\" rel=\"noopener noreferrer\">cockpit dei medici</a> ",
        "SuccessCreated": "Delega creata con successo",
        "SuccessDeleted": "Delega completata con successo",
        "SuccessUpdated": "Delega aggiornata con successo"
      },
      "DoctorCockpitLink": "Cockpit dei medici dell'Hirslanden",
      "EditDelegation": "Modifica la delega",
      "ExternalDelegationDeleteTooltip": "Questa delega è gestita esternamente e può essere annullata solo nella cockpit dei medici",
      "IdpLoginRequired": "Accedere con il proprio account Hirslanden per visualizzare le deleghe gestite dall'esterno.",
      "NoDelegations": "Non sono disponibili deleghe",
      "NoInternalInstitutionsTooltip": "Non avete istituzioni gestite internamente. Le deleghe per le istituzioni gestite esternamente possono essere gestite nel cockpit dei medici.",
      "Table": {
        "Action": "Azione",
        "Edit": "Modifica",
        "Email": "Indirizzo e-mail",
        "Institutions": "Istituzioni rilasciate"
      },
      "Tooltip": {
        "Extern": "esterno",
        "NoInstitutions": "Nessuna istituzione",
        "Title": "Istituzioni rilasciate"
      }
    },
    "LastSentDate": "Inviato su",
    "ServiceProvider": {
      "GroupTranslations": {
        "Anesthesiologists": "Anestesisti",
        "Angestellte Ärzte": "Medici dipendenti",
        "Anästhesisten": "Anestesisti",
        "Gastassistenten": "Assistenti ospiti"
      },
      "Info": "Nell'elenco \"Assistenti con contratto\" compaiono solo i medici che hanno un contratto valido con la compagnia assicurativa selezionata per la clinica in cui il paziente è stato curato il giorno del ricovero. <br><br>Tutti gli altri medici devono essere inseriti manualmente una volta come assistenti ospiti (e segnalati una volta in anticipo alle compagnie assicurative partner secondo le schede informative della sezione Info). <li>Per i medici con un contratto LCA valido il giorno del ricovero del paziente in clinica si applica il fattore proprio dell'assistente.</li><li>Per gli assistenti ospiti senza un contratto LCA valido il giorno del ricovero del paziente in clinica, si applica il fattore del case manager. </li><br>Se il medico ha un contratto valido con la compagnia assicurativa, non può essere utilizzato parallelamente come medico ospite.<br> Si prega di notare che in caso di allacciamenti retroattivi (possibili fino a 4 mesi dopo il giorno del ricovero) o di fatturazione ritardata, la fattura può essere emessa correttamente solo se lo stato contrattuale di tutti gli assistenti è chiaro.",
      "ManagementLinkText": "Link alla voce di {{Name}}",
      "NoServiceProvidersAvailable": "Non ci sono fornitori di servizi disponibili per la selezione."
    },
    "ServiceProviders": {
      "Header": "Fattura medici"
    },
    "Status": {
      "Approved": "Raccolta",
      "Declined": "Rifiutato",
      "Draft": "Bozza",
      "Sent": "Inviato"
    }
  },
  "Languages": {
    "de-CH": "Tedesco",
    "fr-CH": "Francese",
    "it-CH": "Italiano"
  },
  "Nav": {
    "Dropdowns": {
      "Admin": "Admin",
      "Invoice": "InvoicePro"
    },
    "Links": {
      "AcceptInvoiceTerms": "Accettare le condizioni di utilizzo",
      "AdminInfo": "info amministratore",
      "Catalogs": "Cataloghi",
      "ChangePassword": "Modifica della password",
      "ConfigureOtp": "Impostare l'autenticazione a due fattori",
      "Contracts": "Contratti quadro",
      "Dashboard": "Cruscotto",
      "Delegation": "Delega",
      "EditProfile": "Modifica profilo",
      "Emails": "Email",
      "Employee": "Elenchi medici",
      "EventLogs": "Registri eventi",
      "Info": "Info",
      "Institutions": "Istituzioni",
      "InsuranceContracts": "Contratti",
      "Insurances": "Assicurazioni",
      "Invoice": "InvoicePro",
      "InvoiceControlling": "Controllo",
      "InvoiceDelegations": "Deleghe",
      "InvoiceManual": "Guida a InvoicePro",
      "InvoiceServiceProviders": "Fattura medici",
      "InvoiceTerms": "Condizioni di utilizzo",
      "Invoices": "Fatture",
      "LinkHin": "Collegamento login HIN",
      "LinkIdp": "Collega il login {{idp}}",
      "Logout": "Disconnessione",
      "Patients": "Pazienti",
      "PendingInsuranceContracts": "Contratti in sospeso",
      "Rules": "Regole",
      "Statistics": "Statistiche",
      "UserContracts": "I miei contratti",
      "UserGroups": "Gruppi",
      "UserManagement": "Utenti",
      "UserManagementPending": "Richieste"
    },
    "Menus": {
      "UserMenu": "Menu utente"
    },
    "Title": "Medicalculis",
    "Welcome": "Benvenuti"
  },
  "ObjectPermissions": {
    "CanCreate": "Creare",
    "CanDelete": "Cancellare",
    "CanExport": "Esportazione",
    "CanRead": "Leggere",
    "CanUpdate": "Aggiornare",
    "Object": "Tipo di oggetto",
    "ObjectId": "Oggetto",
    "ObjectTypeDescriptions": {
      "User": "Tutti gli utenti",
      "UserContract": "Contratti del assicurazione"
    },
    "ObjectTypes": {
      "CatalogItem": "Posizioni in catalogo",
      "CatalogView": "Vista del catalogo",
      "Employee": "Elenchi di medici",
      "InfoLinks": "Link informativi",
      "UserContract": "Contratti"
    }
  },
  "Providers": {
    "Paginator": {
      "FirstPage_Label": "Prima pagina",
      "ItemsPerPage_Label": "Record di dati per pagina",
      "LastPage_Label": "Ultima pagina",
      "NextPage_Label": "Pagina successiva",
      "Of_Label": "da",
      "PreviousPage_Label": "Pagina precedente"
    }
  },
  "Roles": {
    "Description": {
      "Admin": "L'utente può assegnare ruoli di amministrazione.",
      "CloseContractsEmail": "L'utente riceve un'e-mail quando viene presentata una nuova richiesta di contratto. (L'utente deve essere assegnato anche alla compagnia di assicurazione).",
      "CloseContractsUser": "Le richieste di contratto possono essere presentate dall'utente.",
      "Delegate": "Gli utenti possono creare fatture per conto di altri",
      "EditContracts": "I contratti possono essere accettati o rifiutati.",
      "FileUpload": "L'utente può caricare i file.",
      "Invoice": "Le fatture dell'utente possono essere visualizzate e modificate.",
      "InvoiceControlling": "L'utente può visualizzare, confermare e rifiutare le fatture assicurative.",
      "InvoiceControllingEmail": "L'utente riceve un'e-mail quando le fatture vengono inviate al Controlling.",
      "RoleManagement": "I ruoli possono essere assegnati agli utenti.",
      "UserManagement": "Gli utenti possono essere gestiti.",
      "UserRegisterEmail": "L'utente riceve un'e-mail quando si registrano nuovi utenti.",
      "ViewContracts": "I contratti sono visibili."
    }
  },
  "Statistics": {
    "Filter": {
      "DateFrom": "Periodo da",
      "DateTo": "fino a quando",
      "ExcelExport": "Esportazione di Excel",
      "FeesReport": "Rapporto sulle spese di esportazione",
      "Institutions": "Istituzioni",
      "Insurances": "Assicurazioni",
      "LoadStatistics": "Statistiche di carico",
      "Option": {
        "AllInstitutions": "Tutte le istituzioni",
        "AllInsurances": "Tutte le assicurazioni"
      },
      "Placeholder": {
        "SelectInstitutions": "Tutte le istituzioni",
        "SelectInsurances": "Tutte le assicurazioni"
      }
    },
    "InvoiceStatusPerUser": {
      "Table": {
        "Header": {
          "Approved": "Accettato",
          "Declined": "Rifiutato",
          "Draft": "Bozza",
          "Name": "Nome",
          "Sent": "Inviato"
        },
        "NoData": "Nessun dato disponibile",
        "Totals": "Totale"
      },
      "Title": "Fatture per utente in base allo stato di elaborazione"
    },
    "JoinedDoctorsByInsuranceAndInstitution": {
      "Doctors": {
        "Table": {
          "Header": {
            "ContractMonth": "Contratto Medicalculis firmato nel mese di",
            "ContractYear": "Contratto Medicalculis firmato nell'anno",
            "Count": "Quantità",
            "Institution": "Istituzione",
            "Insurance": "Assicurazione"
          },
          "NoData": "Nessun dato disponibile"
        },
        "Title": "Medici aderenti con contratto Medicalculis per istituzione e data di adesione"
      },
      "Invoices": {
        "Table": {
          "Header": {
            "AverageAmount": "Importo medio della fattura",
            "Count": "Quantità",
            "Institution": "Istituzione",
            "Insurance": "Assicurazione",
            "SentMonth": "Erogato al mese",
            "SentYear": "Spediti nell'anno",
            "TotalAmount": "Importo totale della fattura"
          },
          "NoData": "Nessun dato disponibile"
        },
        "Title": "Fatture inviate dall'ente e dall'assicurazione (escluse le fatture rifiutate)",
        "Totals": "Totale"
      }
    },
    "Table": {
      "CollapsedMessage": "Fare clic qui per visualizzare la tabella"
    },
    "Tabs": {
      "ContractsOverview": "Panoramica del contratto",
      "DoctorsAndInvoices": "Medici e fatture"
    },
    "Tiles": {
      "ApprovedCount": "Accettato",
      "AverageAmount": "Importo medio",
      "DeclinedCount": "Rifiutato",
      "DoctorDistributionByInstitution": {
        "Table": {
          "Header": {
            "Count": "Quantità",
            "Institution": "Istituzione",
            "Percentage": "Per cento"
          },
          "NoData": "Nessun dato disponibile"
        },
        "Title": "Distribuzione dei medici per istituzione"
      },
      "DraftCount": "Bozze",
      "InvoicesSubtitle": "Numero totale di fatture inviate",
      "SentCount": "Inviato",
      "TotalAmountSubtitle": "Importo totale di tutte le fatture inviate",
      "TotalDoctors": "Numero di medici",
      "TotalDoctorsWithContract": "Medici con contratto",
      "TotalDoctorsWithContractSubtitle": "Numero totale di medici con contratto attivo",
      "TotalInvoices": "Fatture",
      "TotalSum": "Importo della fattura"
    },
    "Title": "Statistiche"
  },
  "SupportWidget": {
    "ConfirmationMessage": "Il messaggio è stato inviato con successo.",
    "ContactFormTitle": "Contattateci",
    "OpenHelp": "Aprire la guida",
    "Submit": "Invio",
    "WelcomeMessage": "Benvenuti nel Centro di assistenza"
  },
  "Url": {
    "InvoiceManualPdf": "/pdf/Anleitung_InvoicePro.pdf"
  },
  "User": {
    "Contracts": {
      "AcceptOrConfirmSelected": "Richiesta/conferma contrassegnato",
      "AcceptSelectedDialogText": "Confermo che desidero richiedere un preventivo per i seguenti contratti o stipulare un contratto:</br></br>",
      "AcceptSelectedDialogTitle": "Conferma per richieste di preventivo/contratto",
      "ConfirmSelectedDialogContractText": "{{Title}}:<br><div style=\"margin-left: 25px;\">Fattore LCA: privato = {{VvgP1}} Semiprivato = {{VvgP2}}<br>Totale: privato = {{FactorP1}} Semiprivato = {{FactorP2}}<br>Fattore individuale: {{IndividualFactor}}<br>Valido da {{ValidFrom}} fino a {{ValidUntil}}</div>",
      "ConfirmSelectedDialogContractTextWithoutCompensation": "{{Title}}: {{Validity}}",
      "ConfirmSelectedDialogContractValidity": "Valido dal {{ValidFrom}} al {{ValidUntil}}",
      "ConfirmSelectedDialogContractValidityFromConfirmation": "Valido dalla data di conferma fino al {{ValidUntil}}",
      "ConfirmSelectedDialogText": "Confermo di voler stipulare il seguente contratto, comprese tutte le clausole aggiuntive, in modo giuridicamente vincolante. Inoltre, accetto le Condizioni Generali di Contratto, che regolano i dettagli del contratto.</br></br>",
      "ConfirmSelectedDialogTitle": "Conferma per le conclusioni del contratto",
      "ContractNameHeader": "Nome",
      "ContractStatusHeader": "Stato",
      "ContractValidFromHeader": "Valido da",
      "ContractValidUntilHeader": "Valido fino a",
      "DeclineSelectedDialogText": "Intendete rifiutare le seguenti offerte.<br>Contattate la compagnia di assicurazione via e-mail.<br>La compagnia di assicurazione sarà informata del rifiuto via e-mail.<br>Dopo il rifiuto, potete inviare nuovamente una richiesta di preventivo direttamente qui.</br></br>",
      "DeclineSelectedDialogTitle": "Rifiutare una offerta/le offerte contrattuali",
      "Errors": {
        "NoContractsSelectedText": "Non è stato selezionato alcun contratto.",
        "NoContractsSelectedTitle": "Nessun contratto selezionato",
        "SelectActiveOrIsUserConfirmationPendingContractsOnlyText": "Selezionare solo i contratti attivi o in attesa di conferma.",
        "SelectActiveOrIsUserConfirmationPendingContractsOnlyTitle": "Selezione del contratto non valida",
        "SelectInactiveContractsOnlyText": "Selezionare solo i contratti non ancora attivi.",
        "SelectInactiveContractsOnlyTitle": "Selezione del contratto non valida",
        "SelectPendingOrUserConfirmationPendingContractsOnlyText": "Selezionare solo le richieste di contratto o le conferme di contratto contemporaneamente.",
        "SelectPendingOrUserConfirmationPendingContractsOnlyTitle": "Selezione del contratto non valida",
        "SmsVerificationFailedDialogText": "Codice SMS non corretto!",
        "SmsVerificationFailedDialogTitle": "Codice SMS non corretto.",
        "UserContractNegativeListBlockedContactInsuranceText": "Non è autorizzato a richiedere/confermare i seguenti contratti:{{contracts}}Per ulteriori informazioni, la preghiamo di rivolgersi direttamente alla compagnia assicurativa.",
        "UserContractNegativeListBlockedContactMailText": "Non è autorizzato a richiedere/confermare i seguenti contratti:{{contracts}}Per ulteriori informazioni, la preghiamo di rivolgersi direttamente a <a href=\"mailto:{{email}}\">{{email}}</a>",
        "UserContractNegativeListBlockedTitle": "Richiesta/conferma non possibile",
        "UserMustEnterMobileDialogText": "Per stipulare i contratti è necessario memorizzare un numero di cellulare nel profilo dell'utente. Si prega di inserirlo nelle impostazioni dell'utente.",
        "UserMustEnterMobileDialogTitle": "Il numero di cellulare deve essere registrato"
      },
      "FilterUserContracts": "Visualizzare i contratti inattivi",
      "Header": "Contratti",
      "InfoText": "<p><b>Qui potete visualizzare i vostri contratti e stipularli online:</b></p><ul><li>i contratti accettati qui sono giuridicamente vincolanti. </li><li>Alla voce \"Contenuto del contratto\" potete visualizzare i testi dei contratti in formato PDF.</li><li>Selezionate i contratti desiderati e confermateli con il pulsante corrispondente.</li></ul>",
      "SelectAll": "Selezionare tutto",
      "TerminateOrDeclineSelected": "Disdire/rifiutare i contrassegnati",
      "TerminateSelectedDialogContractAdvice": "<b>Importante</b>: i supplementi di contratto specifici per la sede non vengono annullati se è stato stipulato un altro contratto tra la sede corrispondente e una compagnia assicurativa.",
      "TerminateSelectedDialogContractOutsideWithdrawalText": "Disdetta (oggi) alla {{TerminationDate}} in base al periodo di preavviso.",
      "TerminateSelectedDialogContractText": "{{Title}}:<br><div style=\"margin-left: 25px;\">{{Text}}</div>",
      "TerminateSelectedDialogContractVariousTerminationDatesHint": "Non tutti i contratti hanno la stessa data di cancellazione standard. Se si inserisce una data, la data di cancellazione selezionata verrà utilizzata per tutti i contratti.",
      "TerminateSelectedDialogContractWithinWithdrawalText": "La disdetta entro il periodo di preavviso viene effettuata immediatamente.<br>Il periodo di preavviso è di {{WithdrawalPeriod}} giorni.",
      "TerminateSelectedDialogText": "Confermo di voler disdire i seguenti contratti in modo legalmente vincolante:</br></br>",
      "TerminateSelectedDialogTitle": "Conferma della disdetta del contratto",
      "UserMustEnterMobile": "<p>⚠️ Per poter concludere i contratti, è necessario registrare un numero di cellulare nel profilo dell'utente. Per finalizzare una richiesta, viene inviato un codice via SMS che deve essere inserito per la conferma.Inserirlo nelle impostazioni dell'utente. <br><a class=\"color-white\" href=\"#\" routerlink=\"user/profile\">Collegamento al profilo utente</a></p>",
      "ValidFromOnConfirmation": "a partire dalla conferma"
    },
    "Delegation": {
      "Account": "Conto",
      "ContractoCoreAccount": "Contracto Core",
      "CurrentDelegator": "Delega del medico curante",
      "DelegationInformation": "È possibile emettere fatture per conto dei seguenti utenti:",
      "DelegatorNeedsToRegister": "⚠️ Nessun medico curante collegato",
      "Description": "È possibile creare fatture per conto dei seguenti utenti:",
      "Header": "Delega",
      "NoDelegations": "Lei non ha deleghe.",
      "SourceInternal": "Interno",
      "Table": {
        "Action": "Azione",
        "ConfirmEndMessage": "Volete davvero terminare la delega per {{name}} ? Allora non è più possibile creare fatture per conto di questo utente.",
        "ConfirmEndTitle": "Fine della delega",
        "Email": "Indirizzo e-mail",
        "EndDelegation": "Termina delega",
        "EndDelegationExternalTooltip": "Questa delega è gestita esternamente e non può essere terminata qui.",
        "ExternalBadge": "gestita in modo estensivo",
        "Institutions": "Istituzioni rilasciate",
        "LinkageMissing": "Collegamento mancante",
        "LinkageMissingTooltip": "Il medico curante non è stato collegato a un account. Questo è necessario per creare le fatture.",
        "Name": "Nome e cognome",
        "Tooltip": {
          "Extern": "esterno",
          "NoInstitutions": "Nessuna istituzione",
          "Title": "Istituzioni rilasciate"
        }
      },
      "UserInfos": {
        "GrantedTitle": "Deleghe assegnate",
        "NoDelegations": "Questo utente non ha alcuna delega.",
        "ReceivedTitle": "Deleghe ricevute",
        "SourceContracto": "In Contracto",
        "SourceDoctorCockpit": "Tramite Hirslanden Ärztecockpit"
      },
      "YourAccount": "Il tuo account: "
    },
    "Errors": {
      "EmployedFromAfterEmployedUntil": "La data deve essere antecedente alla data di assunzione.",
      "EmployedUntilAfterEmployedFrom": "La data deve essere successiva a quella impostata."
    },
    "Groups": {
      "AddGroup": "Aggiungi gruppo",
      "AddObjectPermission": "Aggiungere il diritto di proprietà",
      "AdminGroup": "Gruppo amministratore",
      "DeleteObjectPermission": "Cancellare",
      "EditGroup": "Modifica gruppo",
      "Errors": {
        "NameRequired": "Il nome deve essere compilato.",
        "ObjectPermissionNotUnique": "Entry ambigua"
      },
      "GroupType": "Tipo di gruppo",
      "Header": "Gruppi di utenti",
      "InvoiceGroup": "Gruppo di fatturazione",
      "InvoiceGuestAssistant": "Assistente ospite per la fatturazione",
      "Types": {
        "EmployeePerInstitution": "Elenco dei medici per istituto",
        "EmployeePerUser": "Elenco dei medici per utente",
        "Standard": "Standard"
      }
    },
    "Insurance": {
      "CanApproveUserContracts": "Può proporre / rifiutare / rescindere contratti",
      "ContractManager": "Responsabile dei contratti",
      "Function": "Funzione",
      "FunctionHint": "La sua funzione è gestita da healthinal. Se ha bisogno di ulteriori autorizzazioni, si rivolga all'assistenza.",
      "InsuranceRequired": "Selezionare un’assicurazione.",
      "Reviewer": "Verificatore delle prestazioni"
    },
    "Invoice": {
      "AddAnesthesiaSession": "Registrare il tempo di anestesia",
      "AddAssistant": "Aggiungi assistente",
      "AddEditVisits": "Aggiungere/modificare le visite",
      "AddInvoiceSession": "Aggiungi seduta",
      "CloneInvoice": "Copia della fattura",
      "CopyBesrToClipboard": "Copiare il numero di riferimento negli appunti",
      "DeleteInvoiceSession": "Cancellare la seduta",
      "DeleteInvoiceSessionDialogText": "Si vuole davvero cancellare questa seduta?",
      "DeleteServiceProvider": "Cancellare le posizioni di questo fornitore di servizi",
      "DeleteServiceProviderDialogText": "Questo fornitore di servizi deve essere eliminato dalla seduta?",
      "DownloadInvoiceXml": "Scaricare la fattura in formato XML (Forum Datenaustausch)",
      "EditAnesthesiaSession": "Modifica del tempo di anestesia",
      "EditAssistant": "Modifica guidata",
      "EditInvoiceSession": "Modifica dei supplementi",
      "EditInvoiceSurcharges": "Modifica dei supplementi",
      "EditPositions": "Modifica delle voci tariffarie",
      "EditVisits": "Modifica degli visite",
      "InvoiceApprovedChildInvoiceInfoText": "Una copia di questa fattura è già stata creata:",
      "InvoiceApprovedInfoText": "Questa fattura è stata accettata e non può più essere elaborata.",
      "InvoiceApprovedNoChildInvoiceInfoText": "È possibile creare una copia della fattura tramite il seguente link:",
      "InvoiceDeclinedChildInvoiceInfoText": "Una copia di questa fattura è già stata creata:",
      "InvoiceDeclinedInfoText": "La fattura è stata respinta per i seguenti motivi:",
      "InvoiceDeclinedNoChildInvoiceInfoText": "Si prega di creare una copia della fattura tramite il seguente link, in modo da poterla inviare nuovamente:",
      "NoPositionForAssistantInfoText": "L'assistenza non è a pagamento per questa posizione.",
      "NoPositionForServiceProviderInfoText": "Nessuna posizione trovata per questo fornitore di servizi.",
      "ParentInvoiceInfoText": "Questo calcolo è stato ricavato dalla seguente formula:",
      "QrReferenceRequired": "Richiesto il riferimento QR",
      "QrReferenceRequiredError": "È necessario un riferimento QR per il destinatario della fattura selezionato. Inserire il riferimento QR utilizzando il pulsante di modifica della fattura prima di inviarla.",
      "SendInvoice": "Inviare la fattura",
      "SendInvoiceDialogText": "Confermare che si desidera inviare la fattura. In seguito non sarà più possibile apportare modifiche.",
      "SendInvoiceDialogWithInvoiceReceiverText": "Questa fattura sarà inviata elettronicamente a <strong>{{ receiverName }}</strong>. Si prega di non inviare la fattura con altri mezzi.",
      "ShowInvoicePdf": "Mostra fattura"
    },
    "InvoiceVisits": {
      "ChangeServiceProvider": "Registrare le visite per altri fornitori di servizi",
      "SurchargeDisabledTooltip": "È possibile selezionare un supplemento per la visita solo se abbinato a una visita effettuata lo stesso giorno",
      "Title": "Aggiungi visite"
    },
    "Invoices": {
      "AddInvoice": "Creare la fattura",
      "AddInvoiceForPatient": "per il paziente:",
      "AdditionalConfirmation": "Confermo di avere un contratto valido con {{ invoiceReceiver }}",
      "AssignmentAnd": "e",
      "AssignmentFrom": "da",
      "AssignmentUntil": "fino a quando",
      "BackToSsoLogin": "Con {{ sso }} Accedi al tuo account e seleziona direttamente il caso",
      "CaseInsurance": "Assicurazione nel caso selezionato",
      "CaseReset": "Annullamento",
      "CaseSearchLabel": "Trasferimento dei dati dalla custodia",
      "CaseSearchPlaceholder": "Nome Cognome 01.01.1990",
      "CaseSearchResultCount": {
        "Plural": "{{ count }} Casi individuati",
        "Singular": "1 risultato trovato"
      },
      "CaseSearchSearching": "Si cercano casi …",
      "CaseSet": "Dati tratti dal caso {{ caseNumber }}. Controllare e completare le informazioni se necessario.",
      "CaseTreatmentCategories": {
        "General": "Generale",
        "Private": "Privato",
        "SemiPrivate": "Semiprivato"
      },
      "DeleteInvoice": "Cancellare la fattura",
      "DeleteInvoiceText": "Questa fattura deve essere davvero annullata?",
      "EditInvoice": "Modifica fattura",
      "EditPatient": "Modifica del paziente",
      "EditPatientMarker": "(A cura di)",
      "Errors": {
        "AdditionalPatientDataRequired": "Si prega di compilare i dati necessari del paziente.",
        "BankAccountIbanRequired": "L'IBAN deve essere compilato.",
        "BesrInvalid": "Il riferimento QR inserito non è valido.",
        "CaseDataDifference": "Dati di caso divergenti ('{{caseData}}')",
        "CaseNumberInvalid": "Inserire un massimo di 10 cifre.",
        "CaseNumberRequired": "Inserire il numero del caso.",
        "ContractRequired": "Selezionare un contratto",
        "HospitalizationFromAfterHospitalizationUntil": "La data deve essere precedente alla data di ricovero.",
        "HospitalizationFromRequired": "Inserire la data di ospedalizzazione.",
        "HospitalizationUntilBeforeHospitalizationFrom": "La data deve essere successiva alla data di ospedalizzazione.",
        "HospitalizationUntilRequired": "Inserire la data di ricovero.",
        "InsuranceRequired": "Selezionare l'assicurazione",
        "InsuranceTypeRequired": "Selezionare un tipo di assicurazione",
        "MinLengthThree": "Utilizzare almeno tre caratteri",
        "NoActiveContract": "Nessun contratto attivo alla data {{ date }}.",
        "PatientRequired": "Selezionare o creare il paziente",
        "ZsrNumberRequired": "Per la fatturazione è necessario un codice RCC."
      },
      "ForPatient": "dal paziente",
      "GenerateBesr": "Generare automaticamente",
      "GenerateBesrDisclaimer": "Si consiglia di creare questo numero di riferimento nel sistema contabile esterno, in modo che i pagamenti possano essere tracciati correttamente. Se ciò non è necessario o non è possibile, il riferimento può essere generato qui. Non si risponde di errori di elaborazione o di conseguenze legate alla tracciabilità dei pagamenti nel sistema contabile esterno utilizzato per la generazione automatica del riferimento QR.",
      "Header": "Fatture",
      "Hints": {
        "BesrRequiredForSending": "Il destinatario della fattura selezionata richiede un riferimento QR. Questo deve essere inserito prima dell'invio della fattura.",
        "GenerateBesr": "Il numero di riferimento viene generato automaticamente al momento della creazione della fattura. Questo può essere visualizzato nel PDF e in \"Modifica fattura\".",
        "SessionPositionOutOfDateRange": "Una o più voci selezionate non rientrano nel periodo di fatturazione (ricovero da/per). Adattare il periodo o rimuovere le voci interessate.",
        "SessionPositionSourceIsDraft": "Questa voce proviene da una fattura ancora in stato di bozza",
        "SessionPositionsDerivable": "Per gli anestesisti: trasferire le voci disponibili dalla fattura esistente del chirurgo",
        "SessionPositionsDerivableInfo": "Per il numero di caso inserito e il contratto selezionato esiste già una fattura dell'operatore. Selezionare le voci da trasferire."
      },
      "InvalidQrIban": "L'IBAN inserito non è un QR-IBAN valido. Per l'invio al destinatario della fattura selezionato, è necessario registrare un QR-IBAN valido.",
      "InvoiceReceiverSettings": {
        "Errors": {
          "SettingPattern": "Formato non valido",
          "SettingRequired": "L'impostazione è necessaria"
        },
        "Fields": {
          "cdm": {
            "accountNumber": "Numero di conto"
          },
          "medidata": {
            "clientId": "ID cliente MediData",
            "gln": "GLN (fittizio)"
          },
          "zak": {
            "contractId": "Codice contratto della Cassa dentistica"
          }
        },
        "Hints": {
          "cdm": "Inserite qui il vostro numero di conto. Altrimenti verrà utilizzato il vostro RCC (di fatturazione) o quello personale.",
          "zak": "Inserisci qui l'ID contratto che hai ricevuto dalla Cassa dentisti al momento dell'onboarding."
        },
        "MediData": {
          "Instruction1": "Richiedere la connessione <a href='https://www.medidata.ch/md/online/public/onboarding/forms/' target='_blank'>qui</a>.<br />Selezionare <b>Contracto (Medicalculis InvoicePro)</b> come <b>fornitore di software</b> e inserire il seguente GLN <b></b> :",
          "Instruction2": "L'attivazione avviene normalmente entro 24-48 ore.<br />Vi informeremo non appena l'onboarding sarà completato.",
          "Intro": "È necessario un nuovo collegamento MediData a pagamento.",
          "RequestNow": "Richiedi ora"
        },
        "SettingsMissing": "Per questo ricevitore sono necessarie ulteriori impostazioni",
        "Title": "Impostazioni",
        "Zak": {
          "Contact": "Per le procedure di inserimento, si prega di rivolgersi al proprio consulente clienti della Zahnärztekasse.",
          "Instruction": "Inserite quindi il Contract ID ricevuto dalla cassa dentistica nella sezione <b>Impostazioni</b>.",
          "Intro": "Per l'invio delle fatture alla Cassa dei dentisti è necessario un Contract ID. La procedura di onboarding viene svolta dalla Cassa dei dentisti in collaborazione con voi."
        }
      },
      "InvoiceReceiverStatus": {
        "InvoiceReceiverLink": "Aprire a {{ invoiceReceiverTitle }}",
        "InvoiceReceiverReference": "Riferimento",
        "InvoiceReceiverStatusChangedDate": "Ultima modifica",
        "InvoiceReceiverStatusDetails": "Dettagli",
        "Label": "Stato del destinatario",
        "Status": {
          "MediData.Accepted": "Accettato",
          "MediData.Pending": "Rifiutato (dati mancanti)",
          "MediData.Rejected": "Rifiutato",
          "Zak.Accepted": "Approvato",
          "Zak.Pending": "È necessario un approfondimento (vedere la colonna “Dettagli”)",
          "Zak.Rejected": "Rifiutato"
        }
      },
      "InvoiceReceiverTitles": {
        "Caisse des Médecins": "Cassa dei Medici"
      },
      "InvoiceReceivers": "Destinatario della fattura",
      "LogInWithSso": "Accedere con l'account {{ sso }}",
      "LogInWithSsoNudge": "Novità: per selezionare direttamente un caso, effettuare il login con il proprio account {{ sso }}.",
      "ManualDataEntryHint": "Non riuscite a trovare il caso?",
      "ManualDataEntryLink": "Inserire i dati manualmente",
      "NewPatient": "Nuovo paziente",
      "NewPatientMarker": "(Nuovo)",
      "NoCasesFound": {
        "EarliestCaseStart": "L'inizio più precoce del caso nel sistema è il {{ earliestCaseStart }}",
        "NoCasesAvailable": "Non ci sono casi nel sistema",
        "NoUserAssignment": "In base ai dati dei nostri partner, al momento non avete accesso",
        "Reasons": "Possibili motivi:",
        "RetentionHint": "I dati dei casi sono disponibili per {{ retentionInMonths }} Mesi disponibili - i casi più vecchi non vengono quindi trovati",
        "SkillIssue": "Correggere la query di ricerca",
        "Text": "Non sono stati riscontrati casi",
        "UserAssignments": "Secondo i dati dei nostri partner, avete accesso ai casi:"
      },
      "NoCasesFoundReasons": "Possibili motivi:",
      "NoInvoiceReceiver": "Nessun destinatario di fattura elettronica",
      "Patient": "Paziente",
      "PatientDiffersFromSelectedPatient": "Il paziente preselezionato ({{ patientDisplay }}) non corrisponde esattamente ai dati del caso ed è stato quindi sostituito.",
      "ProfileDataMissingInfoText": "Per poter creare una fattura, è necessario aggiungere informazioni al proprio profilo utente. Si prega di aggiornare i campi mancanti.",
      "SaveAndCreate": "Salvare e creare la fattura",
      "SendAnyway": "Inviare comunque",
      "SetCase": "Subentrare",
      "TreatmentReason": {
        "Accident": "Incidente",
        "Disease": "Malattia",
        "Label": "Motivo del trattamento",
        "Maternity": "Maternità",
        "Prevention": "Precauzione"
      },
      "UserProfileDataMissing": "Informazioni sul profilo incomplete"
    },
    "Logins": {
      "LoginDate": "Data di accesso"
    },
    "Management": {
      "ApproveUserButtonText": "Condividi",
      "ApproveUserText": "Vuoi davvero autorizzare questo utente?",
      "ApproveUserTitle": "Condividi utente",
      "DeactivateUserButtonText": "Disattiva utente",
      "DeactivateUserText": "L'utente non può più effettuare l'accesso, ma tutti i dati rimangono invariati in background. È possibile riattivarlo in qualsiasi momento.",
      "DeactivateUserTitle": "Disattiva utente",
      "DeleteUserRequestButtonText": "Elimina",
      "DeleteUserRequestText": "L'utente e tutti i dati ad esso associati verranno eliminati definitivamente. Questa operazione non può essere annullata.",
      "DeleteUserRequestTitle": "Elimina richiesta utente",
      "EditUser": "Modifica utente",
      "ExcelExportGdpr": "Esportazione in Excel con dati personali",
      "ExcelExportGdprText": "L'esportazione contiene dati personali di tutti gli utenti ed è soggetta alla normativa sulla protezione dei dati (DSG/GDPR). Il file deve essere trattato in modo confidenziale, non deve essere trasmesso a soggetti non autorizzati e deve essere cancellato non appena non è più necessario. Si desidera avviare l'esportazione?",
      "Header": "Amministrazione degli utenti",
      "NotifyUserByEmail": "Avvisare l'utente tramite e-mail",
      "PendingHeader": "Richieste degli utenti",
      "ReactivateUser": "Riattivare l'utente",
      "ReactivateUserText": "<p>La riattivazione dell'utente comporta le seguenti azioni:</p><ul><li>L'utente può effettuare nuovamente l'accesso a partire da subito.</li><li>Dopo aver effettuato l'accesso, potrà nuovamente accedere a tutte le funzioni.</li><li>Le richieste di offerta in sospeso ricompaiono negli elenchi corrispondenti.</li></ul>",
      "ReadOnlyUser": "Utente in sola lettura",
      "ReadOnlyUserText": "L'utente è assegnato a più gruppi di cliniche e pertanto non è possibile modificarlo. Per qualsiasi domanda, contattare healthinal."
    },
    "Patients": {
      "AddPatient": "Aggiungi paziente",
      "DeletePatient": "Cancellare il paziente",
      "DeletePatientText": "Questo paziente deve essere cancellato?",
      "EditPatient": "Modifica del paziente",
      "Errors": {
        "CityRequired": "Inserire il nome del luogo",
        "DateOfBirthRequired": "Inserire la data di nascita",
        "FirstNameRequired": "Inserire il nome",
        "GenderRequired": "Selezionare il sesso",
        "LastNameRequired": "Inserire il cognome",
        "PostalCodeRequired": "Inserire il codice postale"
      },
      "Header": "I miei pazienti"
    },
    "Profile": {
      "ChangePersonalInfo": "Cambiare nome o e-mail",
      "QrReferencePrefix": "Prefisso di riferimento QR",
      "QrReferencePrefixTooltip": "Se si desidera generare numeri di riferimento, è possibile definire qui un prefisso opzionale",
      "SavedSuccessful": "I nuovi dati del utente sono stati salvati"
    },
    "SpecialistQualifications": "Titoli specialistici convalidati",
    "SpecialistQualificationsHint": "Questi titoli specialistici sono convalidati esternamente e vengono utilizzati per selezionare il fattore OKP corretto, se necessario.",
    "SpecialistQualificationsNone": "Non sono disponibili titoli specialistici convalidati.",
    "UserContractNegativeList": {
      "Active": "Attualmente bloccato",
      "NoHistory": "Non è mai stato inserito in una lista nera.",
      "Ongoing": "in corso",
      "OpenEnd": "a tempo indeterminato",
      "Past": "Blocchi precedenti",
      "Planned": "Blocchi futuri",
      "Title": "Contratti sospesi"
    },
    "UserStatus": {
      "Active": "Attivo",
      "Deleted": "Disattivato",
      "PendingRequest": "Richiesta in sospeso"
    },
    "UserType": {
      "Delegate": "Delega",
      "InstitutionGroupAdmin": "Amministratore del gruppo clinico",
      "Insurance": "Assicurazione",
      "NotClassified": "Non assegnato",
      "Physician": "Medico curante"
    }
  }
}
